import styles from "./Skills.module.scss";
import HARD_SKILLS from "../../../../constants/hard-skills.json";
import SOFT_SKILLS from "../../../../constants/soft-skills.json";
import TextCursor from "../TextCursor";
import { ReactComponent as UnderlineSvg } from "../../../../assets/images/underline.svg";
import { memo } from "react";

interface Category {
  title: string
  skills: string[]
}

function Skills() {
  const renderSkill = (skill: string, index: number, skills: any) => {
    const isLastChild = index === skills?.length - 1;
    return (
      <span
        key={skill}
        className={`${
          index % 3 === 1 ? styles["category__item--every-second"] : ""
        } ${index % 3 === 2 ? styles["category__item--every-third"] : ""}`}
      >
        {skill}
        {!isLastChild && ", "}
      </span>
    );
  };
  const renderCategory = (category: Category) => {
    return (
      <div key={category.title} className={styles.category}>
        <span className={styles.category__title}>{category.title}</span>
        <div className={styles.category__items}>
          {category.skills?.map(renderSkill)}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.skills}>
      <section className={styles.soft}>
        <div className={styles.header}>
          <TextCursor>
            <span>Soft Skills</span>
          </TextCursor>
          <UnderlineSvg className={styles.underline} />
        </div>
        <TextCursor>
          <p className={styles.soft__list}>{SOFT_SKILLS.map(renderSkill)}</p>
        </TextCursor>
      </section>
      <section className={styles.hard}>
        <div className={styles.header}>
          <TextCursor>
            <span>Hard Skills</span>
          </TextCursor>
          <UnderlineSvg className={styles.underline} />
        </div>
        <TextCursor>
          <div className={styles.hard__list}>
            {HARD_SKILLS.map(renderCategory)}
          </div>
        </TextCursor>
      </section>
    </div>
  );
}

export default memo(Skills);
